import { render, staticRenderFns } from "./bbefore.vue?vue&type=template&id=3a98f7e9&scoped=true&"
import script from "./bbefore.vue?vue&type=script&lang=js&"
export * from "./bbefore.vue?vue&type=script&lang=js&"
import style0 from "./bbefore.vue?vue&type=style&index=0&id=3a98f7e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98f7e9",
  null
  
)

export default component.exports